export default "__VITE_ASSET__BAuiPkJS__"